/**
 * The one visible focus treatment every interactive control shares.
 * Keyboard users always get a ring; mouse users never do (focus-visible).
 */
export const focusRing =
  "outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-base";
